const Forbidden = () => {

    return (
        <div className="flex flex-col h-screen justify-start items-center px-4 font-regular">
            <div>
                <div className="flex flex-col justify-center">
                    <p className="w-full flex justify-center py-4 text-gray-900 text-2xl">Acceso no autorizado</p>
                  
                </div>                
            </div>

            
        </div>
    );
}

export default Forbidden;
